export const clipboard = (str: string) => {
  (navigator as Navigator & {
    clipboard: {
      writeText: (...args: any[]) => any;
    };
  }).clipboard.writeText(str);
};
